import { render, staticRenderFns } from "./summaryList.vue?vue&type=template&id=6b9ffb7b"
import script from "./summaryList.vue?vue&type=script&lang=js"
export * from "./summaryList.vue?vue&type=script&lang=js"
import style0 from "./summaryList.vue?vue&type=style&index=0&id=6b9ffb7b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports